import gql from 'graphql-tag';

const ThematicsOverviewFragment = gql`
  fragment ThematicsOverviewFragment on ThematicsOverviewItem {
    differentielSat
    eindex
    eindexEvolution {
      yearBefore {
        value
        delta
        period {
          startDate
          endDate
        }
      }
      periodBefore {
        value
        delta
        period {
          startDate
          endDate
        }
      }
    }
    mentionEvolution {
      yearBefore {
        value
        delta
        period {
          startDate
          endDate
        }
      }
      periodBefore {
        value
        delta
        period {
          startDate
          endDate
        }
      }
    }
    emotionalIntensity
    emotions {
      anger {
        byMentionCount
        byPercentage
        differentielSat
        impactSat
      }
      calm {
        byMentionCount
        byPercentage
        differentielSat
        impactSat
      }
      disgust {
        byMentionCount
        byPercentage
        differentielSat
        impactSat
      }
      fear {
        byMentionCount
        byPercentage
        differentielSat
        impactSat
      }
      happiness {
        byMentionCount
        byPercentage
        differentielSat
        impactSat
      }
      sadness {
        byMentionCount
        byPercentage
        differentielSat
        impactSat
      }
      surprise {
        byMentionCount
        byPercentage
        differentielSat
        impactSat
      }
    }
    emotionsEvolution {
      periodBefore {
        happiness {
          delta
          value
          period {
            startDate
            endDate
          }
        }
        surprise {
          delta
          value
          period {
            startDate
            endDate
          }
        }
        calm {
          delta
          value
          period {
            startDate
            endDate
          }
        }
        fear {
          delta
          value
          period {
            startDate
            endDate
          }
        }
        anger {
          delta
          value
          period {
            startDate
            endDate
          }
        }
        disgust {
          delta
          value
          period {
            startDate
            endDate
          }
        }
        sadness {
          delta
          value
          period {
            startDate
            endDate
          }
        }
      }
      yearBefore {
        happiness {
          delta
          value
          period {
            startDate
            endDate
          }
        }
        surprise {
          delta
          value
          period {
            startDate
            endDate
          }
        }
        calm {
          delta
          value
          period {
            startDate
            endDate
          }
        }
        fear {
          delta
          value
          period {
            startDate
            endDate
          }
        }
        anger {
          delta
          value
          period {
            startDate
            endDate
          }
        }
        disgust {
          delta
          value
          period {
            startDate
            endDate
          }
        }
        sadness {
          delta
          value
          period {
            startDate
            endDate
          }
        }
      }
    }
    impactSat
    sentimentsEvolution {
      periodBefore {
        negative {
          delta
          period {
            startDate
            endDate
          }
          value
        }
        positive {
          delta
          period {
            startDate
            endDate
          }
          value
        }
        neutral {
          delta
          period {
            startDate
            endDate
          }
          value
        }
      }
      yearBefore {
        negative {
          delta
          period {
            startDate
            endDate
          }
          value
        }
        positive {
          delta
          period {
            startDate
            endDate
          }
          value
        }
        neutral {
          delta
          period {
            startDate
            endDate
          }
          value
        }
      }
    }
    sentiments {
      positive {
        byPercentage
        byMentionCount
        differentielSat
        impactSat
      }
      negative {
        byPercentage
        byMentionCount
        differentielSat
        impactSat
      }
      neutral {
        byPercentage
        byMentionCount
        differentielSat
        impactSat
      }
    }
    isSelected
    mentionCount
    name
    speechEngagement
  }
`;

export default ThematicsOverviewFragment;
